import { render, staticRenderFns } from "./InventoryRow.vue?vue&type=template&id=058277f2&scoped=true&"
import script from "./InventoryRow.vue?vue&type=script&lang=js&"
export * from "./InventoryRow.vue?vue&type=script&lang=js&"
import style0 from "./InventoryRow.vue?vue&type=style&index=0&id=058277f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058277f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VExpansionPanel,VExpansionPanelHeader,VExpansionPanels,VSelect,VSimpleTable,VTextField})
